import { render, staticRenderFns } from "./freephoto.vue?vue&type=template&id=0337a0fe&"
import script from "./freephoto.vue?vue&type=script&lang=js&"
export * from "./freephoto.vue?vue&type=script&lang=js&"
import style0 from "./freephoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports